<template>
  <v-data-table style="min-width: 100%"
    :headers="headers"
    :items="filesPerson"
    item-key="id"
    :page.sync="page"
    :items-per-page.sync="itemsPerPage"
    hide-default-footer
    :loading="loading"
    class="rounded-xl dashed-outlined"
    group-by="typeName"
    :show-group-by="false"
  >
    <template #item.file.filename="{ item }">
      <div style="max-width: 70%" class="text-truncate">{{item.file.filename}}</div>
    </template>

    <template #group.header="{items, isOpen, toggle}">
      <th
        :colspan="headers.length"
        class="header--group-by"
      >
        <div class="text-body-1 d-flex align-center">
          <v-icon small @click="toggle" class="mr-1">{{ isOpen ? 'fa-chevron-up' : 'fa-chevron-down' }}</v-icon>
          {{ items[0].typeName }}
        </div>
      </th>
    </template>

    <template #item.actions="{ item }">
      <v-btn
        small
        fab
        elevation="0"
        :href="item.file.url"
        target="_blank"
      >
        <v-icon small>fa fa-search</v-icon>
      </v-btn>
      <v-btn
        fab
        small
        elevation="0"
        :href="item.file.url"
        download
      >
        <v-icon small>fa fa-arrow-down</v-icon>
      </v-btn>
    </template>
    <template #no-data>
      <v-alert
          class="my-3 text-center rounded-lg"
          dense
          text
          type="warning"
      >
        В портфолио отсутствуют файлы.
      </v-alert>
    </template>
    <template #loading>
      <v-card height="454px" class="d-flex flex-column justify-center align-center">
        Загрузка файлов портфолио
      </v-card>
    </template>
    <template #footer v-if="filesPerson.length > 0">
      <v-row
          class="pb-5 px-4 pt-5"
          align="center"
          justify="center">
        <div class="text-center">
          <v-pagination
              circle
              :color="$store.state.achievement.side_color"
              v-model="page"
              :length="numberOfPages"
              :total-visible="12">
          </v-pagination>
        </div>
        <v-spacer></v-spacer>
        <span class="text-body-2 grey--text">Количество элементотв</span>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                dark
                text
                :color="$store.state.achievement.side_color"
                class="ml-2"
                v-bind="attrs"
                v-on="on">
              {{ itemsPerPage }}
              <v-icon class="ml-1" x-small>fa fa-chevron-up</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)">
              <v-list-item-title>{{ number }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "FileListTab",

  data() {
    return {
      headers: [
        {
          text: 'Группировка',
          value: 'group',
          groupable: false,
          sortable: false,
          width: '5%',
        },
        {
          text: 'Название достижения',
          align: 'name',
          value: 'achievementName',
          groupable: false,
          sortable: false,
          width: '30%',
        },
        {
          text: 'Имя файла',
          align: 'name',
          value: 'file.filename',
          groupable: false,
          sortable: false,
          width: '40%',
        },
        { text: 'Дата', value: 'date', groupable: false, sortable: false,width: '10%'},
        { text: 'Действие', value: 'actions', sortable: false, groupable: false, width: '15%'},
      ],
      itemsPerPage: 36,
      page: 1,
      itemsPerPageArray: [36, 72, 128],
      loading: true,
    }
  },

  async mounted() {
    await this.gePortfolioAchievements();
    this.loading = false;
  },

  computed: {
    ...mapState({
      achievements: state => state.achievement.personAchievements,
    }),

    ...mapGetters({
      filesPerson: "achievement/filesPerson",
    }),

    numberOfPages () {
      return Math.ceil(this.filesPerson.length / this.itemsPerPage)
    },
  },

  methods: {

    ...mapActions({
      gePortfolioAchievements: "achievement/gePortfolioAchievements",
    }),

    updateItemsPerPage (number) {
      this.itemsPerPage = number
    },

  },
}
</script>

<style scoped>
.dashed-outlined {
  border: #EEEEEE 1px solid;
}

.header--group-by {
  background: white;
}
</style>